import { useState } from 'react';

import { Button } from '@progress/kendo-react-buttons';
import { Field, FormRenderProps } from '@progress/kendo-react-form';

import { useGetLookups } from '../hooks/LookupHooks';
import { SbcoDatePicker } from './form/SbcoDatePicker';
import { SbcoDropDownList } from './form/SbcoDropDownList';
import { SbcoInput } from './form/SbcoInput';

export interface DropdownOption {
  text: string;
  value: string;
}

const OTHER_LABEL = 'Other';
const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
};

interface SubscriberDistributionFormProps {
  formRenderProps: FormRenderProps;
}

const SubscriberDistributionForm = ({
  formRenderProps,
}: SubscriberDistributionFormProps) => {
  const { data: methodLookups, isPending: methodsLoading } =
    useGetLookups('MethodOfDistribution');

  const [showOtherInput, setShowOtherInput] = useState(false);

  const handleMethodOfDistributionChange = (event) => {
    const value = event.target.value;

    setShowOtherInput(value.name === OTHER_LABEL);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '16px' }}>
      <div style={rowStyle}>
        <Field
          wrapperStyle={{ width: '240px', marginRight: '20px' }}
          id="subscriberDistributionDate"
          name="subscriberDistributionDate"
          component={SbcoDatePicker}
          label="Date Distributed to Subscribers"
        />

        <Field
          id="methodOfDistribution"
          name="methodOfDistribution"
          wrapperStyle={{ width: '300px', marginRight: '20px' }}
          component={SbcoDropDownList}
          label="Method of Distribution"
          data={methodLookups}
          dataItemKey="id"
          textField="name"
          valueField="id"
          disabled={methodsLoading}
          onChange={handleMethodOfDistributionChange}
        />

        {showOtherInput && (
          <Field
            component={SbcoInput}
            name="otherMethod"
            label="Please specify:"
            placeholder="Enter method of distribution"
            rows={3}
            maxLength={100}
            wrapperStyle={{ width: '400px', marginRight: '20px' }}
          />
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
        <Button
          onClick={formRenderProps.onSubmit}
          type="submit"
          className="btn-submit"
          themeColor="primary"
          disabled={!formRenderProps.allowSubmit}
        >
          Submit: Subscriber Distribution Details for Selected SBCs
        </Button>
      </div>
    </div>
  );
};

export default SubscriberDistributionForm;
